import React from "react";

import Glimmer from "../Glimmer";
import NextImage from "../NextImage";

type Image = {
  src: string;
  alt?: string;
};

type Props = {
  images?: Image[];
  className?: string;
  loading?: boolean;
};

export const shouldRenderImages = (images?: Image[]): boolean =>
  Array.isArray(images) && images.length === 2;

const ImagePair = ({images, className = "", loading}: Props): React.ReactElement =>
  // @ts-expect-error TS2322: Type 'false | Element' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>>'.
  shouldRenderImages(images) && (
    <div className={`dg gafc gg2 ${className}`}>
      {/* @ts-expect-error TS2532: Object is possibly 'undefined'. */}
      {images.map(({src, alt}) => (
        <span key={src} className="fx br2">
          {loading ? (
            <Glimmer height="calc(70px + 4vw)" />
          ) : (
            <NextImage className="br2" src={src} alt={alt} height={500} width={700} />
          )}
        </span>
      ))}
    </div>
  );

export default React.memo(ImagePair);
